const t = (e) => Object.entries(e);
export {
  t as o
};
//# sourceMappingURL=objectEntries-yMIkr2mI.js.map
